import React from 'react'
import ServicesComponent from '../components/Services/ServicesComponent';

const Services = () => {
return ( 
  <ServicesComponent />

);
}

export default Services